export const DataSourceFilterOptions = [
  {value: 'name', label: 'Name', type: 'string'},
  {value: 'url', label: 'URL', type: 'string'},
  {value: 'status', label: 'Status', type: 'status'},
  {value: 'type', label: 'Type', type: 'string'},
  {value: 'order', label: 'Order', type: 'integer'},
]
